// Eye sphere
// export const EYE_SPHERE = {
//   position: [0, 1.3, 0],
//   radius: 2.5,
//   segments: 192,
//   reflectionAlpha: 0.7,
// };
export const EYE_SPHERE = {
  position: [0, 1.25, 0],
  radius: 2.5,
  segments: 192,
  reflectionAlpha: 0.7,
};
// Floor
export const FLOOR_Y = -1.5;
export const SCENE_GROUP_Y = 0.5;

// Reflection — derived from sphere and floor values
const REFLECTION_STRETCH = 1.4;
export const REFLECTION = {
  position: [0, FLOOR_Y * 2 - 0.6, 0],
  scale: [1, -REFLECTION_STRETCH, 1],
};

// Floor world Y (for mirroring the mouse light in EyeSphere)
export const FLOOR_WORLD_Y = SCENE_GROUP_Y + FLOOR_Y;
